export const CUBE_ID = 'facts_slides';
export const REPORT_ID = 'world-overview-major-crops-forecast';
export const REPORT_APE_ID = 'world-overview-major-crops-forecast-ape';